<app-header [forceLightBackground]="true"></app-header>
<div class="join-organisation-page">
  <div class="join-organisation-page--layout">
    <app-consumer-sidebar #sidebar class="join-organisation-page--sidebar"></app-consumer-sidebar>
    <div class="join-organisation-page--content">
      <app-page-header></app-page-header>
      
      <div class="join-organisation-container">
        <!-- Alternative Action Banner - Hide if pending status -->
        <div class="alternative-action-banner" *ngIf="!isPendingStatus">
          <div class="alternative-action-content">
            <span class="alternative-action-text">Don't have an existing organisation?</span>
            <button 
              type="button" 
              class="btn btn-create-entity" 
              (click)="onCreateNewEntity()"
            >
              <svg class="btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M12 5v14M5 12h14" stroke-width="2" stroke-linecap="round"/>
              </svg>
              Create New Organisation
            </button>
          </div>
        </div>

        <div class="form-card">
          <!-- Leaf Pattern Decoration -->
          <div class="join-organisation-leaf-pattern">
            <img src="/assets-leaf.png" alt="" class="join-organisation-leaf-image" />
          </div>
          
          <form [formGroup]="joinOrganisationForm" (ngSubmit)="onSubmit()" class="join-organisation-form">
            <!-- User Name (disabled) -->
            <div class="form-field">
              <label for="userName" class="form-label">
                User Name
              </label>
              <input
                type="text"
                id="userName"
                formControlName="userName"
                class="form-input input-disabled"
                placeholder="User name"
              />
            </div>

            <!-- Registered Email (disabled) -->
            <div class="form-field">
              <label for="registeredEmail" class="form-label">
                Registered Email
              </label>
              <input
                type="email"
                id="registeredEmail"
                formControlName="registeredEmail"
                class="form-input input-disabled"
                placeholder="Email address"
              />
            </div>

            <!-- Name of the entity -->
            <div class="form-field">
              <label for="entityName" class="form-label">
                Organisation Name
                <span class="required-asterisk" *ngIf="!isPendingStatus">*</span>
              </label>
              <div class="autocomplete-wrapper">
                <input
                  type="text"
                  id="entityName"
                  formControlName="entityName"
                  class="form-input"
                  [class.input-error]="isFieldInvalid('entityName') || showOrganisationNotInListMessage()"
                  [class.input-disabled]="isPendingStatus"
                  placeholder="Enter Organisation"
                  autocomplete="off"
                  [disabled]="isPendingStatus"
                  (focus)="onOrganisationInputFocus()"
                  (blur)="onOrganisationInputBlur()"
                />
                <div 
                  class="autocomplete-dropdown" 
                  *ngIf="!isPendingStatus && showOrganisationDropdown && filteredOrganisations.length > 0"
                >
                  <ul class="dropdown-list">
                    <li 
                      *ngFor="let org of filteredOrganisations" 
                      class="dropdown-item"
                      (mousedown)="selectOrganisation(org)"
                    >
                      {{ org }}
                    </li>
                  </ul>
                </div>
              </div>
              <span class="error-message" *ngIf="isFieldInvalid('entityName')">
                Organisation Name is required
              </span>
              <span class="error-message" *ngIf="showOrganisationNotInListMessage()">
                Organisation is not available
              </span>
              <span class="success-message" *ngIf="showOrganisationAvailableMessage()">
                Organisation available
              </span>
            </div>

            <!-- Job Title -->
            <div class="form-field">
              <label for="jobTitle" class="form-label">
                Job Title
                <span class="required-asterisk" *ngIf="!isPendingStatus">*</span>
              </label>
              <input
                type="text"
                id="jobTitle"
                formControlName="jobTitle"
                class="form-input"
                [class.input-error]="isFieldInvalid('jobTitle')"
                [class.input-disabled]="isPendingStatus"
                placeholder="Enter job title"
                [disabled]="isPendingStatus"
              />
              <span class="error-message" *ngIf="isFieldInvalid('jobTitle')">
                Job title is required
              </span>
            </div>

            <!-- Employee ID -->
            <div class="form-field">
              <label for="employeeId" class="form-label">
                Employee ID
                <span class="required-asterisk" *ngIf="!isPendingStatus">*</span>
              </label>
              <input
                type="text"
                id="employeeId"
                formControlName="employeeId"
                class="form-input"
                [class.input-error]="isFieldInvalid('employeeId')"
                [class.input-disabled]="isPendingStatus"
                placeholder="Enter employee ID"
                [disabled]="isPendingStatus"
              />
              <span class="error-message" *ngIf="isFieldInvalid('employeeId')">
                Employee ID is required
              </span>
            </div>

            <!-- Form Actions - Hide submit button if pending status -->
            <div class="form-actions" *ngIf="!isPendingStatus">
              <button
                type="submit"
                class="btn btn-submit"
                [disabled]="joinOrganisationForm.invalid || submitting || !isOrganisationInList()"
              >
                {{ submitting ? 'Joining...' : 'Join Organisation' }}
              </button>
            </div>

            <!-- Pending: Withdraw button -->
            <div class="form-actions form-actions--pending" *ngIf="isPendingStatus">
              <button
                type="button"
                class="btn btn-withdraw"
                [disabled]="withdrawing"
                (click)="onWithdrawClick()"
              >
                {{ withdrawing ? 'Withdrawing...' : 'Withdraw Request' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Success Modal -->
<app-confirmation-dialog
  [(visible)]="showSuccessModal"
  type="success"
  title="Request Sent Successfully"
  message="Your request has been submitted. Your request is awaiting approval from the Organisation Administrator."
  confirmLabel="GOT IT, THANKS!"
  [showCancelButton]="false"
  themeColor="green"
  width="540px"
  nextStepsTitle="What happens next:"
  nextStepsMessage="You'll receive a notification once the Organisation Administrator reviews and responds to your request."
  (onConfirm)="onSuccessModalConfirm()"
  (onClose)="onSuccessModalClose()"
></app-confirmation-dialog>

<!-- Withdraw confirmation -->
<app-confirmation-dialog
  [(visible)]="showWithdrawConfirm"
  type="warning"
  title="Withdraw Request"
  message="Are you sure you want to withdraw your organisation join request? You can submit a new request later."
  confirmLabel="Withdraw"
  cancelLabel="Cancel"
  themeColor="orange"
  width="480px"
  [loading]="withdrawing"
  (onConfirm)="onWithdrawConfirm()"
  (onClose)="onWithdrawConfirmClose()"
></app-confirmation-dialog>